import React from 'react'

export default function Loader() {
    return (
        <div id="loading">
      <img src="../assets/images/other/loader.svg" className="loader-img" alt="Loader" />
    </div>
    )
}
